<div class="flex size-full flex-col place-content-center" [style.gap]="gap">
  @for (row of rows(); track $index) {
    <div class="flex place-content-center" [style.gap]="gap">
      @for (stop of row; track stop.uid) {
        @let state = getStopState(stop);
        <rid-location-stop
          class="pointer-events-auto shrink-0"
          [class.cursor-pointer]="state !== 'LOCKED'"
          [style.width]="cardWidth()"
          [stop]="stop"
          [state]="state"
          [date]="$ridHomeworkService.stopDate(stop)"
          [assignmentsFinished]="$ridHomeworkService.finishedPerAssignment(stop)"
          [pulsing]="$ridHomeworkService.isStopToDoToday(stop)"
          (click)="state !== 'LOCKED' ? $ridHomeworkService.goToStop(stop) : undefined"
        />
      }
    </div>
  }
</div>
